<template>
  <div class="card mg-b-10">
    <div class="card-header d-flex align-items-center justify-content-between">
      <h6 class="mg-b-0">
        {{ b != undefined && b.nm != undefined ? b.nm : "" }}
      </h6>
    </div>
    <ul class="list-group list-group-flush">
      <li
        @click="$emit('on-detail', t)"
        class="list-group-item d-flex align-items-center bd-0"
        v-for="(t, i) in tasks"
        :key="i"
        role="button"
      >
        <div class="avatar d-none d-sm-block">
          <span :class="`avatar-initial rounded-circle bg-teal`">
            <i class="icon ion-md-list"></i>
          </span>
        </div>
        <div class="pd-l-10">
          <h6 class="tx-14 tx-semibold mg-b-5">{{ t.task }}</h6>
        </div>
        <div class="mg-l-auto text-right">
          <p class="tx-medium text-info font-weight-bold mg-b-0">{{ t.i1 }}</p>
          <small class="tx-12 mg-b-0">сэдэв</small>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    tasks: {
      type: Array,
      default: () => []
    },
    b: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style></style>
